export default __webpack_public_path__ + "static/media/remote-left-right.dfec026d.png";